import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { IframePreviewState } from 'owa-sxsdata';

export interface IframePreviewProps {
    className?: string;
    onLoad: () => void;
    viewState: IframePreviewState;
}

const styles = require('./IFramePreview.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function IFramePreview(props: IframePreviewProps) {
    React.useEffect(() => {
        if (iFrameElement.current) {
            iFrameElement.current.onload = onIFrameLoad;
        }
    }, []);
    const iFrameElement = React.useRef<HTMLIFrameElement>();
    const onIFrameLoad = () => {
        props.onLoad();
    };
    const mainClassNames = classNames(props.className, styles.main);
    return (
        <div className={mainClassNames}>
            <iframe
                className={styles.preview}
                src={props.viewState.previewUrl}
                ref={iFrameElement}
            />
        </div>
    );
});
